import React from 'react';
import { faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section className="py-24 bg-[#0b0014]">
      <div className="max-w-[900px] mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          FAQs
        </h2>
        
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white/[0.02] border border-white/[0.06] rounded-xl px-6 data-[state=open]:border-purple-500/30 transition-colors"
            >
              <AccordionTrigger className="text-left text-white hover:text-purple-300 text-lg font-medium py-5 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        
        <div className="mt-12 p-6 bg-white/[0.02] border border-white/[0.06] rounded-xl">
          <p className="text-sm text-gray-500 italic leading-relaxed">
            Read Stocks Protocol's Risk Disclosure at{' '}
            <a href="#" className="text-purple-400 hover:text-purple-300 transition-colors">stocksprotocol.com/legal</a>
            {' '}as well as the Base Prospectus and related Final Terms at{' '}
            <a href="#" className="text-purple-400 hover:text-purple-300 transition-colors">stocksprotocol.com/documentation</a>
            {' '}to learn more.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
